export const translation = {
  nav: {
    home: 'Home',
    guides: 'Guides',
    categories: 'Categories',
    article: 'Article',
    shoppingGuide: 'Shopping Guide',
    explore: 'Explore Spreadsheet',
    buyNow: 'Buy It Now',
  },
  hero: {
    eyebrow: 'THE ALLCHINABUY RESOURCE HUB',
    headline: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Guides in One Place',
    subheadline: 'Explore organized AllChinaBuy spreadsheet resources, product categories, trusted seller guides, QC information, shipping costs, warehouse tips, reviews and practical buying guides before you buy.',
    ctaExplore: 'Explore AllChinaBuy Spreadsheet',
    ctaBrowse: 'Browse Buying Guides',
    trustLine: 'Independent Resource • Practical Guides • Updated Content',
  },
  whatIs: {
    h2: 'What Is the AllChinaBuy Spreadsheet?',
    copy: 'The AllChinaBuy Spreadsheet is a structured resource that makes product discovery easier. Explore products, categories, sellers, QC information, shipping resources and buying guides from one organized location.',
  },
  everythingNeed: {
    h2: 'Everything You Need to Research AllChinaBuy Products',
    cards: {
      productDiscovery: 'Product Discovery',
      productDiscoveryDesc: 'Explore organized product and category resources.',
      sellerResearch: 'Seller Research',
      sellerResearchDesc: 'Compare seller information and buying considerations.',
      qcInfo: 'QC Information',
      qcInfoDesc: 'Understand quality-check photos and their limitations.',
      shippingGuides: 'Shipping Guides',
      shippingGuidesDesc: 'Learn about shipping methods, costs and common questions.',
    },
  },
  popularResources: {
    h2: 'Popular AllChinaBuy Resources',
    spreadsheet: 'AllChinaBuy Spreadsheet',
    review: 'AllChinaBuy Review',
    shippingCost: 'AllChinaBuy Shipping Cost',
    warehouse: 'AllChinaBuy Warehouse',
    coupon: 'AllChinaBuy Coupon',
    discountCode: 'AllChinaBuy Discount Code',
    legit: 'AllChinaBuy Legit',
    qc: 'AllChinaBuy QC',
    trustedSellers: 'Trusted Sellers',
    buyingGuides: 'Buying Guides',
  },
  productCategories: {
    h2: 'Explore AllChinaBuy Product Categories',
    shoes: 'Shoes',
    hoodiesSweaters: 'Hoodies/Sweaters',
    tShirts: 'T-Shirts',
    jackets: 'Jackets',
    pantsShorts: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    otherStuff: 'Other Stuff',
  },
  howToUse: {
    h2: 'How to Use the AllChinaBuy Spreadsheet',
    steps: {
      step1: 'Choose a category.',
      step2: 'Research products and sellers.',
      step3: 'Compare options.',
      step4: 'Review QC information.',
      step5: 'Check warehouse and shipping information.',
      step6: 'Make an informed decision.',
    },
    cta: 'Start Exploring the Spreadsheet',
  },
  researchFirst: {
    h2: 'Research First. Buy With More Confidence.',
    copy: 'Understanding seller research, product information, QC processes, shipping options and purchasing risks helps you make smarter decisions. Our guides walk you through each step of the research process so you can buy with confidence.',
  },
  stayInformed: {
    h2: 'Stay Informed Before You Buy',
    copy: 'Always verify product information, seller details, payment information, shipping conditions and URLs. No spreadsheet can guarantee quality, authenticity or transaction results.',
    cta: 'Read the Safety Guide',
  },
  readyToExplore: {
    h2: 'Ready to Explore AllChinaBuy?',
    copy: 'Start with the AllChinaBuy Spreadsheet, compare products and sellers, learn about QC and shipping, and use our buying guides to make better-informed decisions.',
    ctaExplore: 'Explore AllChinaBuy Spreadsheet',
    ctaVisit: 'Visit Main Website',
  },
  footer: {
    disclaimer: 'This website is an independent informational resource. Information may change and should be independently verified before purchasing.',
    copyright: '© 2026 AllChinaBuy Spreadsheet. All rights reserved.',
    links: {
      home: 'Home',
      guides: 'Guides',
      safety: 'Safety',
      contact: 'Contact',
    },
  },
  categories: {
    shoes: 'Shoes',
    hoodiesSweaters: 'Hoodies/Sweaters',
    tShirts: 'T-Shirts',
    jackets: 'Jackets',
    pantsShorts: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    otherStuff: 'Other Stuff',
  },
  pillarArticles: {
    h2: 'Pillar Guides & Resources',
  },
  article: {
    readMore: 'Read More',
    relatedArticles: 'Related Articles',
    backToHome: 'Back to Home',
  },
};